(function () {
  const wrapper = document.querySelector('.template-collection .collection-wrapper');
  if (!wrapper) return;

  document.querySelectorAll('[data-dy-toggle-filters]').forEach((button) => {
    const label = button.querySelector('.dy-plp-filters-toggle__label');
    button.addEventListener('click', () => {
      const hidden = wrapper.classList.toggle('collection-wrapper--filters-hidden');
      button.setAttribute('aria-expanded', hidden ? 'false' : 'true');
      if (label) {
        label.textContent = hidden ? 'Mostrar filtros' : 'Ocultar filtros';
      }
    });
  });
})();
